import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { createInviteUser, listUserTypes } from '../../actions/user';
import { openDialog, closeDialog } from '../../actions/dialog';

import { storeWithExpiration } from '../../utils/common';
import { VALID_EMAIL_REGEX, SUPER_ADMIN } from '../../config/app_config';

import DialogForm from '../shared/DialogForm';
import UserInviteForm from './UserInviteForm';

const FORM_ID = 'userInviteForm';

export class UserInviteFormContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    cancelDialogFunction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    createInviteUserAction: PropTypes.func.isRequired,
    listUserTypesAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    userTypes: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { accountId, listUserTypesAction } = this.props;
    const token = storeWithExpiration.get('token');
    listUserTypesAction(accountId, token);
  };

  performInviteUserAction = params => {
    const { createInviteUserAction, accountId, closeDialogAction } = this.props;
    const token = storeWithExpiration.get('token');
    const inviteInfo = {
      firstName: params.firstName,
      lastName: params.lastName,
      email: params.newUserEmail,
      accessLevel: params.accessLevel,
      phoneNumber: params.phoneNumber,
      isPrimary: params.isPrimary || false,
    };
    closeDialogAction('addUserDialog');
    createInviteUserAction(token, accountId, inviteInfo);
  };

  render() {
    const {
      cancelDialogFunction,
      show,
      handleSubmit,
      invalid,
      isSuperAdmin,
      submitting,
      userTypes,
    } = this.props;

    const dialogContent = (
      <UserInviteForm
        invalid={invalid}
        isSuperAdmin={isSuperAdmin}
        userTypes={userTypes}
        handleSubmit={handleSubmit}
        submitting={submitting}
        closeFunction={cancelDialogFunction}
        submitFunction={this.performInviteUserAction}
      />
    );
    return (
      <DialogForm
        cancelFunction={cancelDialogFunction}
        cancelText="Close"
        content={dialogContent}
        id="addUserDialog"
        show={show}
        title="New User"
      />
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.firstName || values.firstName === '') {
    errors.firstName = 'Required';
  }
  if (!values.lastName || values.lastName === '') {
    errors.lastName = 'Required';
  }
  if (!values.newUserEmail || values.newUserEmail === '') {
    errors.newUserEmail = 'Required';
  } else if (!VALID_EMAIL_REGEX.test(values.newUserEmail)) {
    errors.newUserEmail = 'Invalid User Email';
  }
  if (!values.accessLevel || values.accessLevel === '' || values.accessLevel === '-------') {
    errors.accessLevel = 'Required';
  }
  if (!values.phoneNumber || values.phoneNumber === '') {
    errors.phoneNumber = 'Required';
  }
  return errors;
};

const UserInviteFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(UserInviteFormContainer);

function mapStateToProps(state) {
  const { user, userInvite, userList } = state;
  const userTypes = userList.get('userTypes');
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  return { isSuperAdmin, userInvite, userTypes };
}

export default connect(mapStateToProps, {
  createInviteUserAction: createInviteUser,
  closeDialogAction: closeDialog,
  listUserTypesAction: listUserTypes,
  openDialogAction: openDialog,
})(UserInviteFormContainerRF);
